/**
 * Typed bridge over a defect in `@spazious/react-backoffice`'s older option
 * aliases: they mark `mutationKey` / `queryKey` as required even though every
 * hook defaults them internally, so a plain `{ onSuccess, onError }` literal
 * is rejected. Adding a key the call site doesn't already pass is NOT an
 * option — it would change the react-query cache key and invalidation
 * behavior — so this helper makes both keys optional instead.
 *
 * Always pass the hook's option type explicitly so the literal stays fully
 * checked against it:
 *
 *   usePauseOrder(legacyHookOptions<BackofficePauseOrderMutationHookOptions>({ onSuccess, onError }))
 *
 * Delete alongside the lib when SPAZ2-2916 completes.
 */
export const legacyHookOptions = <T,>(
  options: Omit<T, 'mutationKey' | 'queryKey'> & {
    mutationKey?: string | string[];
    queryKey?: string;
  }
): T => options as T;
